import { useEffect, useState, type ReactNode } from "react";
import { NavLink } from "react-router-dom";
import { useAuth } from "../auth";
import { supabase } from "../lib/supabase";

const baseNavigation = [
  { href: "/", label: "Inventaire", end: true },
  { href: "/loans", label: "Prêts en cours" },
  { href: "/history", label: "Historique" },
  { href: "/alerts", label: "Alertes" },
];

export function Layout({ children }: { children: ReactNode }) {
  const { profile, signOut } = useAuth();
  const [alertCount, setAlertCount] = useState(0);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const refresh = async () => {
      const { count } = await supabase.from("stock_alerts").select("id", { count: "exact", head: true }).is("acknowledged_at", null);
      setAlertCount(count ?? 0);
    };
    refresh();
    const channel = supabase.channel("stock-alert-count")
      .on("postgres_changes", { event: "*", schema: "public", table: "stock_alerts" }, refresh)
      .subscribe();
    return () => { supabase.removeChannel(channel); };
  }, []);

  const navigation = profile?.role === "admin"
    ? [...baseNavigation, { href: "/admin/items", label: "Gérer le stock" }, { href: "/users", label: "Utilisateurs" }, { href: "/qr", label: "QR codes" }]
    : baseNavigation;

  return (
    <div className="app-shell">
      <header className="topbar">
        <NavLink className="brand-mark" to="/">
          <span className="brand-icon">STC</span>
          <span><strong>Stock Conférence</strong><small>Maintenance · BRU</small></span>
        </NavLink>
        <button className="menu-button" type="button" onClick={() => setMenuOpen((value) => !value)} aria-expanded={menuOpen}>Menu</button>
        <nav className={menuOpen ? "open" : ""} aria-label="Navigation principale">
          {navigation.map((item) => (
            <NavLink key={item.href} to={item.href} end={"end" in item ? item.end : false} onClick={() => setMenuOpen(false)}>
              {item.label}{item.href === "/alerts" && alertCount > 0 && <span className="nav-count">{alertCount}</span>}
            </NavLink>
          ))}
        </nav>
        <div className="account-menu">
          <span><strong>{profile?.full_name}</strong><small>{profile?.role === "admin" ? "Administrateur" : "Utilisateur"}</small></span>
          <button type="button" onClick={signOut}>Déconnexion</button>
        </div>
      </header>
      <main className="content">{children}</main>
    </div>
  );
}
